// src/constants/leegality.config.js
// Frontend configuration for Leegality eSign integration
// This config contains only client-safe settings (no sensitive credentials)
//
// Usage:
// import leegalityConfig from '../constants/leegality.config';
// const webhookConfig = leegalityConfig.buildWebhookConfig();

const config = {
  // Environment
  nodeEnv: process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || 'development',

  // Base URLs
  baseUrl: process.env.REACT_APP_BASE_URL || window.location.origin,
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || `${window.location.origin}/api/v1`,

  // Leegality Configuration (Frontend-safe settings only)
  leegalityBaseUrl: process.env.REACT_APP_NODE_ENV === 'production'
    ? 'https://app1.leegality.com/api'
    : 'https://sandbox.leegality.com/api',

  // Webhook Configuration
  webhookPath: '/esign/webhook',
  webhookVersion: '2.5',

  // Computed webhook URL
  get webhookUrl() {
    return `${this.baseUrl}/api/v1${this.webhookPath}`;
  },

  get errorWebhookUrl() {
    return `${this.baseUrl}/api/v1/esign/webhook/error`;
  },

  // eSign Configuration
  eSign: {
    profileId: process.env.REACT_APP_LEEGALITY_PROFILE_ID || 'JizPQg2',
    defaultInviteeName: 'Customer',
    defaultInviteeEmail: 'customer@example.com',
    signTimeoutMinutes: 30,
  },

  // Validation (for frontend-safe settings)
  isValid() {
    const missing = [];
    if (!this.baseUrl) missing.push('REACT_APP_BASE_URL');
    if (!this.apiBaseUrl) missing.push('REACT_APP_API_BASE_URL');

    if (missing.length > 0) {
      console.error('❌ Missing required frontend environment variables:', missing.join(', '));
      return false;
    }
    return true;
  },

  // Log configuration (without sensitive data)
  logConfig() {
    console.log('🔧 Frontend Leegality Configuration:');
    console.log('   Environment:', this.nodeEnv);
    console.log('   Base URL:', this.baseUrl);
    console.log('   API Base URL:', this.apiBaseUrl);
    console.log('   Webhook URL:', this.webhookUrl);
    console.log('   Leegality API:', this.leegalityBaseUrl);
    console.log('   Profile ID:', this.eSign.profileId);
  },

  // Helper methods
  getESignPayloadDefaults() {
    return {
      profileId: this.eSign.profileId,
      invitees: [{
        name: this.eSign.defaultInviteeName,
        email: this.eSign.defaultInviteeEmail,
        phone: '',
        webhook: {
          url: this.webhookUrl,
          version: this.webhookVersion,
          errorUrl: this.errorWebhookUrl
        }
      }]
    };
  },

  // Build webhook configuration for eSign requests
  buildWebhookConfig() {
    return {
      url: this.webhookUrl,
      version: this.webhookVersion,
      errorUrl: this.errorWebhookUrl
    };
  }
};

// Validate configuration on import
if (!config.isValid()) {
  console.warn('⚠️ Frontend Leegality configuration validation failed. Some features may not work correctly.');
}

// Log configuration in development
if (config.nodeEnv === 'development') {
  config.logConfig();
}

export default config;